import { render, staticRenderFns } from "./ProjectContainer.vue?vue&type=template&id=5e042859&scoped=true&"
import script from "./ProjectContainer.vue?vue&type=script&lang=ts&"
export * from "./ProjectContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e042859",
  null
  
)

export default component.exports